"use client";

import { useTranslations } from "next-intl";
import { Modal } from "./Modal";

export function BuilderUnsavedChangesDialog({
  open,
  message,
  onConfirm,
  onClose,
}: {
  open: boolean;
  message?: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const t = useTranslations("components.builderUnsavedChanges");

  return (
    <Modal open={open} onClose={onClose} title={t("title")} size="sm">
      <p className="text-sm leading-6 text-text-secondary">{message ?? t("message")}</p>
      <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button type="button" className="btn-base btn-secondary" onClick={onClose}>{t("stay")}</button>
        <button type="button" className="btn-base btn-danger" onClick={onConfirm}>{t("discard")}</button>
      </div>
    </Modal>
  );
}
